document.addEventListener("DOMContentLoaded", function() {
    var toggleButton = document.getElementById("toggle-button");
    var textContainer = document.getElementById("text-container");

    toggleButton.addEventListener("click", function() {
        if (textContainer.classList.contains("expanded")) {
            textContainer.classList.remove("expanded");
            toggleButton.innerText = "Read More";
        } else {
            textContainer.classList.add("expanded");
            toggleButton.innerText = "Read Less";
        }
    });
});